<template>
  <div>
    <vx-card>
      <div>
        <div class="flex justify-end">
          <vs-button v-if="!!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
        <p class="title mt-5 mb-5">사업장 정보</p>
        <div class="writeGridContainer">
          <div>
            <div>사업장명(필수)</div>
            <ml-input v-model="form.field_name" />
          </div>
          <div>
            <div>부서명</div>
            <vs-select
              class="w-full xl:w-48 com-name-select"
              autocomplete
              v-model="form.meta.com_name"
              :danger="isComNameInvalid"
              danger-text="목록에 없는 부서명입니다. 올바른 부서명을 선택해주세요."
            >
              <vs-select-item v-for="(company, index) in companyList" :key="index" :text="company.text" :value="company.value" />
            </vs-select>
          </div>
          <div>
            <div>팀명</div>
            <div>
              <company-selector multiple v-model="form.meta.team_company_list" :data-key="['id', 'com_name']"/>
            </div>
          </div>
          <div>
            <div>담당 주무관</div>
            <ml-input v-model="form.manager_name" />
          </div>
          <div>
            <div>부서장</div>
            <ml-input v-model="form.meta.부서장" />
          </div>
          <div>
            <div>사업기간</div>
            <date-selector-rang :value="{ sDate: form.work_begin_at, eDate: form.work_end_at }" @sDate="form.work_begin_at = $event" @eDate="form.work_end_at = $event" />
          </div>
          <div>
            <div>사업장 연락처</div>
            <ml-input v-model="form.phone" placeholder="예) 055-123-4567" />
          </div>
          <div>
            <div>사업장 주소</div>
            <ml-input v-model="form.address"/>
          </div>
        </div>
      </div>

      <!-- 담당 부서 및 수급업체 현황 -->
      <company-add-module v-model="responsibleDepartmentList" @remove="removeCompany" detailLabelComName="부서(업체)명" />

      <!-- 참여 인원 정보 -->
      <!-- <company-user-auth-module
        popupTitle="부서(기관) 불러오기"
        permissionHead="권한설정"
        :colData="[
          { head: '구분', key: 'company_id' },
          { head: '사용자명', key: 'name' },
          { head: '연락처', key: 'phone' },
        ]"
        :users="userList"
        v-model="joinUsers"
      /> -->

      <div class="my-8" style="display: grid; grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div>
          <p class="title-n">현장조감도</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />
        </div>
        <div>
          <p class="title-n">현장약도</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />
        </div>
        <div>
          <p class="title-n">현장사진</p>
          <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />
        </div>
      </div>

      <file-upload-module v-model="form.fileList" />
    </vx-card>
  </div>
</template>

<script>
import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import { GNSC_DEPARTMENT_LIST } from "@/constant/gnscDepartments";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {CompanySelector, DateSelectorRang, DateSelector, SearchNavStartEnd, CompanyUserAuthModule, CompanyAddModule, FileUploader, FileInput, FileUploadModule },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        manager_name: "", // 담당 주무관
        address: "", //주소
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 완료
        phone: "", // 대표번호
        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진

        photoList: [],
        fileList: [],

        meta: {
          부서장: "",
          com_name: "", // 부서명
          team_company_list: [], //팀(업체) 목록
        },
      },
      responsibleDepartmentList: [], // 담당부서
      userList: [],
      joinUsers: [],
    };
  },
  computed: {
    fieldId() {
      return this.$route.params.fieldId;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    tabName() {
      return "사업장";
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    companyList () {
      // 부서명("과") 선택지는 로그인 사용자의 소속에 따라 달라지는 회사 트리 대신,
      // 검색 컴포넌트(SearchSelectCompanyName.vue)와 동일한 고정 목록을 사용한다.
      // 트리 기반으로 생성하면 팀 소속 사용자에게 "과"가 아닌 "팀"이 선택지로 노출되어
      // 부서명에 팀명이 저장되는 문제가 있었다. (gnsc)
      const resultList = [
        {
          value: '',
          text: '전체',
          company_path: '',
        }
      ]

      GNSC_DEPARTMENT_LIST.forEach((item) => {
        resultList.push({
          value: item,
          text: item,
          company_path: '',
        })
      })

      return resultList;
    },
    // 저장된 부서명이 선택지 목록에 없는 경우(예: 과거에 팀명이 저장된 문서) true
    isComNameInvalid () {
      const comName = this.form.meta.com_name;
      if (!comName) return false;
      return !this.companyList.some((company) => company.value === comName);
    }
  },
  watch: {
    async responsibleDepartmentList() {
      await this.initMembers();
    },
  },
  created() {
    if (this.fieldId) {
      this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = JSON.parse(JSON.stringify(this.$store.state.project.fieldInfo));
      if (info.meta) {
        let meta = JSON.parse(info.meta);
        // meta 가 length 가 0인 array 로 넘어올 경우, json 으로 초기화
        if (Array.isArray(meta) && meta.length === 0) meta = {};
        if (!meta.com_name) meta.com_name = "";
        if (!meta.team_company_list) meta.team_company_list = [];
        info.meta = meta;
      } else info.meta = {
        com_name: "",
        team_company_list: [],
      };

      this.joinUsers = info.users;
      this.form = { ...info };

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      // TODO: photoList 사용처가 없음
      if (this.form.photoList && this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }
        this.responsibleDepartmentList = companies;

        await this.initMembers();
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.responsibleDepartmentList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    onClickTab(tabIndex) {
      const type = this.$route.query.type;
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace-list", query: { type } });
      } else if (tabIndex === 1) {
        const proj_id = this.$route.params.proj_id;
        if (type) this.$router.push({ name: "field-info-type", params: { proj_id, type } });
        else this.$router.push({ name: "field-workplace-info" });
      }
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    onClickSave() {
      if (!this.form.field_name || !String(this.form.field_name).trim()) {
        UiUtil.alertDialog("사업장명을 입력해 주세요.");
        return;
      }
      if (this.form.phone && !/^[0-9+()\-\s]+$/.test(this.form.phone)) {
        UiUtil.alertDialog("사업장 연락처는 숫자와 하이픈(-)만 입력할 수 있습니다.");
        return;
      }
      // 목록에 없는 부서명(예: 과거에 팀명이 저장된 문서)인 경우, 올바른 부서명 선택을 유도한다
      if (this.isComNameInvalid) {
        this.$vs.notify({
          title: "부서명 확인",
          text: "목록에 없는 부서명입니다. 올바른 부서명을 선택해주세요.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        return;
      }

      const company_ids = [];
      for (const com of this.responsibleDepartmentList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      this.$emit("save", this.form);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
  },
};
</script>

<style scoped lang="scss">
// 부서명 select 검증(오류) 메시지 가독성 개선 (기본 0.65rem -> 키움)
.com-name-select::v-deep .con-text-validation {
  font-size: 0.85rem;

  .span-text-validation {
    padding-top: 4px;
    line-height: 1.3;
  }
}

.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
